import { useMediaQuery } from 'react-responsive';

export const useMobile = () => useMediaQuery({ query: '(max-width: 550px)' });
export const useMobileLandscape = () => useMediaQuery({ query: '(max-width: 1000px) and (orientation:landscape)' });
